<div class="add-container">
	<h1 class="add-title">Generează un nou borderou</h1>
	<form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
		<div class="row">
            <mat-form-field class="col-md-6" (click)="picker.open()">
                <mat-label>Dată Document(e) de la</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="date_start" (focus)="picker.open()" readonly/>
                <mat-error *ngIf="!form.controls['date_start'].valid && form.controls['date_start'].touched">
                    Câmp obligatoriu
                </mat-error>
                <mat-hint>ZZ/LL/AAAA</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="col-md-6" (click)="picker2.open()">
                <mat-label>Dată Document(e) până la</mat-label>
                <input matInput [matDatepicker]="picker2" formControlName="date_end" (focus)="picker2.open()" readonly />
                <mat-error *ngIf="!form.controls['date_end'].valid && form.controls['date_end'].touched">
                    Câmp obligatoriu
                </mat-error>
                <mat-hint>ZZ/LL/AAAA</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
		</div>

        <button type="button" class="btn btn-primary w-100 my-3" (click)="searchDocuments()">Caută documente</button>

        <div class="table-container" [ngClass]="{ 'hide-table': isLoading || !searchPressed}">
            <table id="datatable" class="row-border hover w-100" datatable [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"></table>
        </div>
        <div class="text-center" *ngIf="!searchPressed && !isLoading">
            <span class="noType-text">Selectați o perioadă</span>
        </div>
        <div class="section-spinner position-absolute" *ngIf="isLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
            </div>
        </div>

		<div class="row mt-3">
			<div class="col d-flex justify-content-between">
				<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
					{{ helper.dialogConfig.buttonLabels.close }}
				</button>
				<button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="selectedRowIds.length == 0">
					{{ helper.dialogConfig.buttonLabels.save }}
				</button>
			</div>
		</div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>